import { useAuth } from '@fourthwall/auth'
import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { useDeleteCreatorIntegrationMutation } from '@mutations'
import { routing } from '@utils/routing'

import { useGoogleAnalyticsConfigurationQuery } from '../queries/useGoogleAnalyticsConfigurationQuery'

const PROVIDER = 'google-analytics'

export const useGoogleAnalyticsConnection = () => {
  const { keycloak } = useAuth()
  const { deleteCreatorIntegrationMutation } = useDeleteCreatorIntegrationMutation()
  const { googleAnalyticsConfigurationQuery, invalidateGoogleAnalyticsConfigurationQuery } =
    useGoogleAnalyticsConfigurationQuery()

  const disconnect = async (onSuccess?: () => void) => {
    await deleteCreatorIntegrationMutation.mutateAsync(PROVIDER, {
      onSuccess: () => {
        invalidateGoogleAnalyticsConfigurationQuery()
        onSuccess?.()
      },
    })
  }

  const connectLink = CreatorIntegrationsApiClient.appAuthorizationUrl({
    app: PROVIDER,
    token: keycloak?.token,
    returnUrl: `${window.location.origin}${routing.analytics.self}`,
  }).toString()

  return {
    status: googleAnalyticsConfigurationQuery.data?.type,
    isLoading: googleAnalyticsConfigurationQuery.isLoading,
    connectLink,
    disconnect,
  }
}
